export const NavbarLinks = [
  {
    label: 'Home',
    link: '/',
  },
  {
    label: 'Services',
    link: '/services',
  },
  {
    label: 'News',
    link: '/news',
  },
  {
    label: 'About Us',
    link: '/about-us',
    sublinks: [
      {
        label: 'Testimonals',
        link: '/testimonals',
      },
      {
        label: 'Faqs',
        link: '/faqs',
      },
    ],
  },

  {
    label: 'Contact Us',
    link: '/contact-us',
  },
  {
    label: 'More',

    sublinks: [
      {
        label: 'Terms & Conditions',
        link: '/terms-conditions',
      },
      {
        label: 'Privacy Policy',
        link: '/privacy-policy',
      },
    ],
  },
];
export const NavbarLinkMd = [
  {
    label: 'Home',
    link: '/',
  },
  {
    label: 'Services',
    link: '/services',
  },
  {
    label: 'News',
    link: '/news',
  },
  {
    label: 'About Us',
    link: '/about-us',
    sublinks: [
      {
        label: 'Testimonals',
        link: '/testimonals',
      },
      {
        label: 'Faqs',
        link: '/faqs',
      },
    ],
  },

  {
    label: 'More',

    sublinks: [
      {
        label: 'Terms & Conditions',
        link: '/terms-conditions',
      },
      {
        label: 'Privacy Policy',
        link: '/privacy-policy',
      },
    ],
  },
];
export const FooterLinks = [
  {
    label: 'Home',
    link: '/',
  },
  {
    label: 'About Us',
    link: '/about-us',
    sublinks: [
      {
        label: 'Testimonals',
        link: '/testimonals',
      },
      {
        label: 'Faqs',
        link: '/faqs',
      },
    ],
  },

  {
    label: 'Services',
    link: '/services',
  },
  {
    label: 'News',
    link: '/news',
  },
  {
    label: 'Contact Us',
    link: '/contact-us',
  },
  {
    label: 'Privacy Policy',
    link: '/privacy-policy',
  },
  {
    label: 'Terms & Conditions',
    link: '/terms-conditions',
  },
];
